import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _localeData, _localeNames;

import React from "react";
import { IntlProvider } from "react-intl";
import locale_AR from "@locale/ar.json";
import locale_AZ from "@locale/az.json";
import locale_BG from "@locale/bg.json";
import locale_BN from "@locale/bn.json";
import locale_CA from "@locale/ca.json";
import locale_CS from "@locale/cs.json";
import locale_DA from "@locale/da.json";
import locale_DE from "@locale/de.json";
import locale_EL from "@locale/el.json";
import locale_ES from "@locale/es.json";
import locale_ES_CO from "@locale/es_CO.json";
import locale_ET from "@locale/et.json";
import locale_FA from "@locale/fa.json";
import locale_FI from "@locale/fi.json";
import locale_FR from "@locale/fr.json";
import locale_HI from "@locale/hi.json";
import locale_HU from "@locale/hu.json";
import locale_HY from "@locale/hy.json";
import locale_ID from "@locale/id.json";
import locale_IS from "@locale/is.json";
import locale_IT from "@locale/it.json";
import locale_JA from "@locale/ja.json";
import locale_KO from "@locale/ko.json";
import locale_LT from "@locale/lt.json";
import locale_MN from "@locale/mn.json";
import locale_NB from "@locale/nb.json";
import locale_NL from "@locale/nl.json";
import locale_PL from "@locale/pl.json";
import locale_PT from "@locale/pt.json";
import locale_PT_BR from "@locale/pt_BR.json";
import locale_RO from "@locale/ro.json";
import locale_RU from "@locale/ru.json";
import locale_SK from "@locale/sk.json";
import locale_SL from "@locale/sl.json";
import locale_SQ from "@locale/sq.json";
import locale_SR from "@locale/sr.json";
import locale_SV from "@locale/sv.json";
import locale_TH from "@locale/th.json";
import locale_TR from "@locale/tr.json";
import locale_UK from "@locale/uk.json";
import locale_VI from "@locale/vi.json";
import locale_ZH_HANS from "@locale/zh-Hans.json";
import locale_ZH_HANT from "@locale/zh-Hant.json";
export var Locale;

(function (Locale) {
  Locale["EN"] = "en";
  Locale["PL"] = "pl";
  Locale["AR"] = "ar";
  Locale["AZ"] = "az";
  Locale["BG"] = "bg";
  Locale["BN"] = "bn";
  Locale["CA"] = "ca";
  Locale["CS"] = "cs";
  Locale["DA"] = "da";
  Locale["DE"] = "de";
  Locale["EL"] = "el";
  Locale["ES"] = "es";
  Locale["ES_CO"] = "es_CO";
  Locale["ET"] = "et";
  Locale["FA"] = "fa";
  Locale["FI"] = "fi";
  Locale["FR"] = "fr";
  Locale["HI"] = "hi";
  Locale["HU"] = "hu";
  Locale["HY"] = "hy";
  Locale["ID"] = "id";
  Locale["IS"] = "is";
  Locale["IT"] = "it";
  Locale["JA"] = "ja";
  Locale["KO"] = "ko";
  Locale["LT"] = "lt";
  Locale["MN"] = "mn";
  Locale["NB"] = "nb";
  Locale["NL"] = "nl";
  Locale["PT"] = "pt";
  Locale["PT_BR"] = "pt_BR";
  Locale["RO"] = "ro";
  Locale["RU"] = "ru";
  Locale["SK"] = "sk";
  Locale["SL"] = "sl";
  Locale["SQ"] = "sq";
  Locale["SR"] = "sr";
  Locale["SV"] = "sv";
  Locale["TH"] = "th";
  Locale["TR"] = "tr";
  Locale["UK"] = "uk";
  Locale["VI"] = "vi";
  Locale["ZH_HANS"] = "zh-Hans";
  Locale["ZH_HANT"] = "zh-Hant";
})(Locale || (Locale = {}));

var localeData = (_localeData = {}, _defineProperty(_localeData, Locale.EN, undefined), _defineProperty(_localeData, Locale.PL, locale_PL), _defineProperty(_localeData, Locale.AR, locale_AR), _defineProperty(_localeData, Locale.AZ, locale_AZ), _defineProperty(_localeData, Locale.BG, locale_BG), _defineProperty(_localeData, Locale.BN, locale_BN), _defineProperty(_localeData, Locale.CA, locale_CA), _defineProperty(_localeData, Locale.CS, locale_CS), _defineProperty(_localeData, Locale.DA, locale_DA), _defineProperty(_localeData, Locale.DE, locale_DE), _defineProperty(_localeData, Locale.EL, locale_EL), _defineProperty(_localeData, Locale.ES, locale_ES), _defineProperty(_localeData, Locale.ES_CO, locale_ES_CO), _defineProperty(_localeData, Locale.ET, locale_ET), _defineProperty(_localeData, Locale.FA, locale_FA), _defineProperty(_localeData, Locale.FI, locale_FI), _defineProperty(_localeData, Locale.FR, locale_FR), _defineProperty(_localeData, Locale.HI, locale_HI), _defineProperty(_localeData, Locale.HU, locale_HU), _defineProperty(_localeData, Locale.HY, locale_HY), _defineProperty(_localeData, Locale.ID, locale_ID), _defineProperty(_localeData, Locale.IS, locale_IS), _defineProperty(_localeData, Locale.IT, locale_IT), _defineProperty(_localeData, Locale.JA, locale_JA), _defineProperty(_localeData, Locale.KO, locale_KO), _defineProperty(_localeData, Locale.LT, locale_LT), _defineProperty(_localeData, Locale.MN, locale_MN), _defineProperty(_localeData, Locale.NB, locale_NB), _defineProperty(_localeData, Locale.NL, locale_NL), _defineProperty(_localeData, Locale.PT, locale_PT), _defineProperty(_localeData, Locale.PT_BR, locale_PT_BR), _defineProperty(_localeData, Locale.RO, locale_RO), _defineProperty(_localeData, Locale.RU, locale_RU), _defineProperty(_localeData, Locale.SK, locale_SK), _defineProperty(_localeData, Locale.SL, locale_SL), _defineProperty(_localeData, Locale.SQ, locale_SQ), _defineProperty(_localeData, Locale.SR, locale_SR), _defineProperty(_localeData, Locale.SV, locale_SV), _defineProperty(_localeData, Locale.TH, locale_TH), _defineProperty(_localeData, Locale.TR, locale_TR), _defineProperty(_localeData, Locale.UK, locale_UK), _defineProperty(_localeData, Locale.VI, locale_VI), _defineProperty(_localeData, Locale.ZH_HANS, locale_ZH_HANS), _defineProperty(_localeData, Locale.ZH_HANT, locale_ZH_HANT), _localeData);
export var localeNames = (_localeNames = {}, _defineProperty(_localeNames, Locale.AR, "العربيّة"), _defineProperty(_localeNames, Locale.AZ, "Azərbaycanca"), _defineProperty(_localeNames, Locale.BG, "български"), _defineProperty(_localeNames, Locale.BN, "বাংলা"), _defineProperty(_localeNames, Locale.CA, "català"), _defineProperty(_localeNames, Locale.CS, "česky"), _defineProperty(_localeNames, Locale.DA, "dansk"), _defineProperty(_localeNames, Locale.DE, "Deutsch"), _defineProperty(_localeNames, Locale.EL, "Ελληνικά"), _defineProperty(_localeNames, Locale.EN, "English"), _defineProperty(_localeNames, Locale.ES, "español"), _defineProperty(_localeNames, Locale.ES_CO, "español de Colombia"), _defineProperty(_localeNames, Locale.ET, "eesti"), _defineProperty(_localeNames, Locale.FA, "فارسی"), _defineProperty(_localeNames, Locale.FI, "suomi"), _defineProperty(_localeNames, Locale.FR, "français"), _defineProperty(_localeNames, Locale.HI, "Hindi"), _defineProperty(_localeNames, Locale.HU, "Magyar"), _defineProperty(_localeNames, Locale.HY, "հայերեն"), _defineProperty(_localeNames, Locale.ID, "Bahasa Indonesia"), _defineProperty(_localeNames, Locale.IS, "Íslenska"), _defineProperty(_localeNames, Locale.LT, "lietuvių"), _defineProperty(_localeNames, Locale.IT, "italiano"), _defineProperty(_localeNames, Locale.JA, "日本語"), _defineProperty(_localeNames, Locale.KO, "한국어"), _defineProperty(_localeNames, Locale.MN, "Mongolian"), _defineProperty(_localeNames, Locale.NB, "norsk (bokmål)"), _defineProperty(_localeNames, Locale.NL, "Nederlands"), _defineProperty(_localeNames, Locale.PL, "polski"), _defineProperty(_localeNames, Locale.PT, "Português"), _defineProperty(_localeNames, Locale.PT_BR, "Português Brasileiro"), _defineProperty(_localeNames, Locale.RO, "Română"), _defineProperty(_localeNames, Locale.RU, "Русский"), _defineProperty(_localeNames, Locale.SK, "Slovensky"), _defineProperty(_localeNames, Locale.SL, "Slovenščina"), _defineProperty(_localeNames, Locale.SQ, "shqip"), _defineProperty(_localeNames, Locale.SR, "српски"), _defineProperty(_localeNames, Locale.SV, "svenska"), _defineProperty(_localeNames, Locale.TH, "ภาษาไทย"), _defineProperty(_localeNames, Locale.TR, "Türkçe"), _defineProperty(_localeNames, Locale.UK, "Українська"), _defineProperty(_localeNames, Locale.VI, "Tiếng Việt"), _defineProperty(_localeNames, Locale.ZH_HANS, "简体中文"), _defineProperty(_localeNames, Locale.ZH_HANT, "繁體中文"), _localeNames);
var dotSeparator = "_dot_";
var sepRegExp = new RegExp(dotSeparator, "g");

function getKeyValueJson(messages) {
  if (messages) {
    var keyValueMessages = {};
    return Object.entries(messages).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          id = _ref2[0],
          msg = _ref2[1];

      acc[id.replace(sepRegExp, ".")] = msg.string;
      return acc;
    }, keyValueMessages);
  }
}

var defaultLocale = Locale.EN;

var LocaleProvider = function LocaleProvider(_ref3) {
  var children = _ref3.children;
  // For now locale can be set here
  var locale = Locale.EN;
  return React.createElement(IntlProvider, {
    defaultLocale: defaultLocale,
    locale: locale,
    messages: getKeyValueJson(localeData[locale]),
    key: locale
  }, children);
};

export { LocaleProvider };